// extracted by mini-css-extract-plugin
export default {"Modal":"style_Modal__fOJeO","visible":"style_visible__-fYEG","content":"style_content__Ubkxj","groupInput":"style_groupInput__Gl+B3","btnInput":"style_btnInput__GcDzG"};